"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
function exponentialBackoff(startWaitTime, retryNumber, waitBackoff, getResult) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var waitTime, i, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // TODO: jitter?
          waitTime = startWaitTime;
          i = 0;
        case 2:
          if (!(i < retryNumber)) {
            _context.next = 14;
            break;
          }
          _context.next = 5;
          return getResult();
        case 5:
          result = _context.sent;
          if (!result) {
            _context.next = 8;
            break;
          }
          return _context.abrupt("return", result);
        case 8:
          _context.next = 10;
          return sleep(waitTime);
        case 10:
          waitTime *= waitBackoff;
        case 11:
          i++;
          _context.next = 2;
          break;
        case 14:
          return _context.abrupt("return", null);
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
exports.default = exponentialBackoff;
// Sleep given number of millis.
function sleep(millis) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, millis);
  });
}